import { useAuthContext } from "./useAuthContext"
import { useBookingsContext } from "./useBookingsContext"

export const useLogout = () => {

    const { dispatch } = useAuthContext()
    const { dispatch: bookingsDispatch } = useBookingsContext()

    const logout = () => {

        localStorage.removeItem('user')

        dispatch({ type: 'LOGOUT' })
        bookingsDispatch({ type: 'SET_BOOKINGS', payload: null })
        bookingsDispatch({ type: 'SET_BOOKED_BALCONY_SLOTS', payload: null })
        bookingsDispatch({ type: 'SET_BOOKED_LAUNDRY_SLOTS', payload: null })
    }

    return { logout }
}